import { createUseStyles } from 'react-jss'
import { lightGrey, trafficRedDark } from '../../../../../../../../../../../styles/const/colors'
import { transitionShort } from '../../../../../../../../../../../styles/const/common'
import { smartWordWrapMixin } from '../../../../../../../../../../../styles/mixins/common'

const useStyles = createUseStyles({
  field: {
    marginTop: [0, '!important']
  },
  headerRow: {
    fontSize: 12,
    '& p': {
      marginTop: [0, '!important']
    }
  },
  container: {
    width: '100%',
    borderBottom: {
      color: lightGrey,
      style: 'solid',
      width: 1
    },
    padding: '8px 0',

    '&:last-child': {
      marginBottom: 10
    }
  },
  row: {
    color: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 10
  },
  label: {
    flexGrow: 1,
    maxWidth: '117px',
    ...smartWordWrapMixin()
  },
  inlineField: {
    width: [100, '!important'],
    maxWidth: [100, '!important'],
    margin: 0,
    // reset .section .field margin
    marginTop: '0 !important',

    '&.inlineField': {
      margin: '0',
      '& input': {
        height: 40
      }
    }
  },
  selectedValueRemove: {
    marginLeft: 5,
    cursor: 'pointer',
    width: 12,
    height: 12,
    '& path': {
      fill: lightGrey,
      transition: transitionShort
    },
    '&:hover path': {
      fill: trafficRedDark
    }
  }
})

export default useStyles
